import Document from './Document';

type Grade = 'A' | 'B' | 'C' | 'D' | 'E';

interface Certificate {
    id: number;
    companyId: number;
    creationDate: string;
    modificationDate: string;
    issueDate: string;
    grade: Grade;
    parent: Certificate | null;
    co2Eq: number | null;
    kgReducedPlastic: number | null;
    isExpired: boolean;
    assessmentId: number | null;
    documentName: string;
    document: Document | null;
}

const EmptyCertificate: Certificate = {
    id: 0,
    companyId: 0,
    creationDate: '',
    modificationDate: '',
    issueDate: '',
    grade: 'A',
    parent: null,
    co2Eq: null,
    kgReducedPlastic: null,
    isExpired: false,
    assessmentId: null,
    documentName: '',
    document: null
};

export { EmptyCertificate };
export type { Grade };

export default Certificate;
